import { formatPromocodeTime } from '../../utils';

export const generateDescription = (
	playTimePassedSec: number,
	playTimeRequiredSec: number,
) => {
	const { target, unit } = formatPromocodeTime(
		playTimePassedSec,
		playTimeRequiredSec,
	);

	return `Отыграй ${target} ${unit}`;
};
